const ModifierApplicabilityConditions = {
	currentConditionTargetsPerUid: {},
	conditionBlocksPerUid: {},
	blankRemoveButton: `<span class='Tag__remove-tag j-modifier-applicability-remove-block'>&times;</span>`,
	blankTags: Object.entries({
		enacting_actor: ["blue-dark", true],
		all_actors: ["green", true],
		top_in_property: ["lila", true],
		bottom_in_property: ["pink", true],
		actors_with_function: ["yellow", true],
		property_item: ["gray", false],
	}).reduce((result, [tagName, tagProps], index) => {
		result[tagName] =
			`<div class='Tag Tag--in-playarea Tag--with-right-floating-button Tag--${tagProps[0]}' style='${tagProps[1] ? "display: block; margin-top: 8px" : ""}'><span></span></div>`;
		return result;
	}, {}),

	init(formFieldId, presentData) {
		// pp.log("init", formFieldId, Object.assign([], presentData));
		if (!Array.isArray(presentData)) {
			// Means that it will be an empty hash
			presentData = [];
		}
		this.conditionBlocksPerUid[formFieldId] = [];
		this.currentConditionTargetsPerUid[formFieldId] = $(
			`input[name='applicability_condition_block_uid_${formFieldId}']:checked`,
		).val();

		$(`input[name='applicability_condition_block_uid_${formFieldId}']`).on(
			"click",
			(event) => {
				// @ts-expect-error
				$(event.currentTarget).closest("label").tab("show");
				this.currentConditionTargetsPerUid[formFieldId] = $(
					event.currentTarget,
				).val();
			},
		);
		$("label[data-target]")
			.off("shown.bs.tab")
			.on("shown.bs.tab", function () {
				// @ts-expect-error
				var $targetPane = $($(this).attr("data-target"));
				// @ts-expect-error
				pp.backend.formHelpers.initSelect2For($targetPane.find("select"));
			});

		$(document)
			.off("click", ".j-modifier-applicability-remove-block")
			.on("click", ".j-modifier-applicability-remove-block", (event) => {
				const formFieldIds = Object.keys(
					pp.backend.formHelpers.modifierApplicabilityConditions
						.conditionBlocksPerUid,
				);
				for (let index in formFieldIds) {
					const formFieldId = formFieldIds[index];
					if (formFieldId == "observeChangeHandlers") {
						continue;
					}
					pp.backend.formHelpers.modifierApplicabilityConditions.handleRemoveClick(
						formFieldId,
						event,
					);
				}
			});
		$(document)
			.off("click", ".j-add-applicability-condition-button")
			.on("click", ".j-add-applicability-condition-button", (event) => {
				const formFieldId = $(event.target).attr("data-uid");
				this.handleAddButtonClick(formFieldId);
			});

		this.conditionBlocksPerUid.observeChange(
			formFieldId,
			function (oldval, newval) {
				pp.backend.formHelpers.modifierApplicabilityConditions.handleConditionChanges(
					formFieldId,
					oldval,
					newval,
				);
			},
		);

		// Add the unique ids for the data from Rails manually before
		presentData.forEach((arrayItem, index) => {
			if (typeof arrayItem != "object") {
				const hashifiedArrayItem = {
					hashifiedArrayEntry: arrayItem,
					randomId: pp.viewHelpers.generateRandomId(),
				};
				presentData[index] = hashifiedArrayItem;
			} else {
				// expect a hash with an array of the format e.g. `{actors_with_function: ['amalia']}`, append an *Array* of random ids for each entry under e.g. `actors_with_function`
				let randomIds = [];
				for (let arrayItemIndex in Object.values(arrayItem)[0]) {
					randomIds.push(pp.viewHelpers.generateRandomId());
				}
				arrayItem.randomIds = randomIds;
				presentData[index] = arrayItem;
			}
		});
		this.conditionBlocksPerUid[formFieldId] = presentData;
	},

	handleConditionChanges(formFieldId, oldval, newval) {
		// pp.log("handleConditionChanges", formFieldId, oldval, newval);
		$(
			`.j-modifier-applicability-conditions-playarea[data-uid='${formFieldId}']`,
		).html("");
		// Wipe current input data
		this.addBlocksVisually(formFieldId, newval);
		this.setInputTextarea(formFieldId, newval);
	},

	addBlocksVisually(formFieldId, newConditionsArray) {
		newConditionsArray.forEach((arrayItem) => {
			const conditionType = Object.keys(arrayItem)[0];
			if (conditionType == "hashifiedArrayEntry") {
				this.addHashifiedArrayItemVisually(formFieldId, arrayItem);
			} else {
				this.addNestedHashVisually(formFieldId, conditionType, arrayItem);
			}
		});
		if (!newConditionsArray.length) {
			this.getPlayareaElem(formFieldId).html(
				I18n.t("cms.modifiers.no_target_defined"),
			);
		}
	},

	addHashifiedArrayItemVisually(formFieldId, hashifiedArray) {
		const conditionType = hashifiedArray.hashifiedArrayEntry;
		const randomId = hashifiedArray.randomId;
		const displayNameOfTarget = this.getConditionTypeLabel(
			formFieldId,
			conditionType,
		)
			.find(".Tag")
			.text();
		let $headlineTag = $(this.blankTags[conditionType]);
		$headlineTag.find("span").html(displayNameOfTarget);
		$headlineTag.attr("data-random-id", randomId);
		let $removeButton = $(this.blankRemoveButton);
		$headlineTag.append($removeButton);
		this.getPlayareaElem(formFieldId).append($headlineTag);
	},

	addNestedHashVisually(formFieldId, conditionType, arrayItem) {
		// Expect the `hashValue` to be an array
		const hashValue = arrayItem[conditionType];
		let $newTag;
		const displayNameOfTarget = this.getConditionTypeLabel(
			formFieldId,
			conditionType,
		)
			.find(".Tag")
			.text();

		let $headlineTag = $(this.blankTags[conditionType]);
		$headlineTag.find("span").html(displayNameOfTarget);
		this.getPlayareaElem(formFieldId).append($headlineTag);
		for (const index in hashValue) {
			const conditions = hashValue[index];
			// @ts-expect-error
			$newTag = $(this.blankTags.property_item);
			$newTag.find("span").html(conditions);
			$newTag.attr("data-random-id", arrayItem.randomIds[index]);
			let $removeButton = $(this.blankRemoveButton);
			$newTag.append($removeButton);
			this.getPlayareaElem(formFieldId).append($newTag);
		}
	},

	handleAddButtonClick(formFieldId) {
		const module = pp.backend.formHelpers.modifierApplicabilityConditions;
		const currentConditionTarget =
			module.currentConditionTargetsPerUid[formFieldId];
		const $conditionTypePane = $(
			`#applicability_condition_block_${currentConditionTarget}_uid_${formFieldId}_pane`,
		);
		let dupedConditionBlocks = Object.assign(
			[],
			module.conditionBlocksPerUid[formFieldId],
		);
		let conditionBlockEntryWithType;
		const indexOfConditionBlockEntryWithType = dupedConditionBlocks.findIndex(
			(arrayItem) => {
				return currentConditionTarget == Object.keys(arrayItem)[0]; // There should always ever be a hash with one key in each array item
			},
		);
		if (indexOfConditionBlockEntryWithType == -1) {
			// Build a new entry
			conditionBlockEntryWithType = {};
		} else {
			// Found an entry, re-use it
			conditionBlockEntryWithType = dupedConditionBlocks.splice(
				indexOfConditionBlockEntryWithType,
				1,
			)[0]; // `splice` returns an array
		}

		switch (currentConditionTarget) {
			case "all_actors": // Such multiple conditions. Wow.
			case "enacting_actor":
				conditionBlockEntryWithType.hashifiedArrayEntry =
					currentConditionTarget;
				conditionBlockEntryWithType.randomId =
					pp.viewHelpers.generateRandomId();
				break;

			case "top_in_property":
			case "bottom_in_property":
				const $comparisonValueInput = $conditionTypePane.find(
					"[name='condition_rank_value']",
				);
				// @ts-expect-error
				const parsedRank = parseInt($comparisonValueInput.val(), 10);
				if (isNaN(parsedRank)) {
					pp.notifications.display("error", `Please enter a valid number!`);
					return;
				}
				if (conditionBlockEntryWithType[currentConditionTarget] === undefined) {
					conditionBlockEntryWithType[currentConditionTarget] = [];
					conditionBlockEntryWithType.randomIds = [];
				}
				conditionBlockEntryWithType[currentConditionTarget].push(parsedRank);
				conditionBlockEntryWithType.randomIds.push(
					pp.viewHelpers.generateRandomId(),
				);
				break;

			case "actors_with_function":
				const $targetFunctionInput = $conditionTypePane.find(
					".j-condition-function",
				);
				// pp.log("pane", $targetFunctionInput);
				if (conditionBlockEntryWithType[currentConditionTarget] === undefined) {
					conditionBlockEntryWithType[currentConditionTarget] = [];
					conditionBlockEntryWithType.randomIds = [];
				}
				conditionBlockEntryWithType[currentConditionTarget].push(
					$targetFunctionInput.val(),
				);
				conditionBlockEntryWithType.randomIds.push(
					pp.viewHelpers.generateRandomId(),
				);
				break;

			default:
				pp.notifications.display("error", "Unknown condition!");
		}
		// Remove the (default) "enacting Actor" option if it's the only option
		if (
			dupedConditionBlocks.length == 1 &&
			Object.keys(dupedConditionBlocks[0]).includes("hashifiedArrayEntry") &&
			Object.values(dupedConditionBlocks[0]).includes("enacting_actor")
		) {
			dupedConditionBlocks = [];
		}
		dupedConditionBlocks.push(conditionBlockEntryWithType);
		module.conditionBlocksPerUid[formFieldId] = dupedConditionBlocks;
	},

	handleRemoveClick(formFieldId, event) {
		const randomId = parseInt(
			// @ts-expect-error
			$(event.currentTarget).closest(".Tag").attr("data-random-id"),
		);
		// pp.log("into handleRemoveClick -- formFieldId, event, randomId", formFieldId, event, randomId);

		let dupedConditionBlocks = Object.assign(
			[],
			pp.backend.formHelpers.modifierApplicabilityConditions
				.conditionBlocksPerUid[formFieldId],
		);
		for (let index in dupedConditionBlocks) {
			const arrayItem = dupedConditionBlocks[index];
			// pp.log("at index, arrayItem", index, arrayItem);

			const conditionType = Object.keys(arrayItem)[0];
			if (conditionType == "hashifiedArrayEntry") {
				if (arrayItem.randomId != randomId) {
					continue;
				}
				// else
				dupedConditionBlocks.splice(index, 1);
			} else {
				const indexOfNestedArrayEntry = arrayItem.randomIds.indexOf(randomId);
				// pp.log("index:", indexOfNestedArrayEntry);
				if (indexOfNestedArrayEntry == -1) {
					// pp.log("next");
					continue; // Means that we are looking at an array item that does not contain the random id we are looking for
				}
				// @ts-expect-error
				delete dupedConditionBlocks[index][conditionType].splice(
					indexOfNestedArrayEntry,
					1,
				);
				// @ts-expect-error
				delete dupedConditionBlocks[index].randomIds.splice(
					indexOfNestedArrayEntry,
					1,
				);
				// @ts-expect-error
				if (Object.keys(dupedConditionBlocks[index][conditionType]).length) {
					continue;
				}
				// else remove the whole block
				dupedConditionBlocks.splice(index, 1);
			}
		}
		pp.backend.formHelpers.modifierApplicabilityConditions.conditionBlocksPerUid[
			formFieldId
		] = dupedConditionBlocks;
	},

	getPlayareaElem(formFieldId) {
		// pp.log("getPlayareaElem", $(`.j-modifier-applicability-conditions-playarea[data-uid='${formFieldId}']`));
		return $(
			`.j-modifier-applicability-conditions-playarea[data-uid='${formFieldId}']`,
		);
	},

	getConditionTypeLabel(formFieldId, conditionType) {
		// pp.log("getConditionTypeLabel", $(`div.form-group[data-uid='${formFieldId}']`).find(`label[data-condition-type='${conditionType}']`));
		return $(`div.form-group[data-uid='${formFieldId}']`).find(
			`label[data-condition-type='${conditionType}']`,
		);
	},

	setInputTextarea(formFieldId, newval) {
		const filteredInput = JSON.stringify(
			newval,
			this.filterConditionBlocksForRails,
		);
		// pp.log("setInputTextarea", formFieldId, $(`textarea[name*='applicability_conditions'][data-uid='${formFieldId}']`));
		$(
			`textarea[name*='applicability_conditions'][data-uid='${formFieldId}']`,
		).val(filteredInput);
	},

	filterConditionBlocksForRails(key, value) {
		// pp.log("filterConditionBlocksForRails", key, value)
		// Convert the hashified array entry back to an array
		if (Object.keys(value).includes("hashifiedArrayEntry")) {
			return value.hashifiedArrayEntry;
		} else if (["randomId", "randomIds", "tagTextContent"].includes(key)) {
			return undefined;
		}
		return value;
	},
};

export default ModifierApplicabilityConditions;
